// extracted by mini-css-extract-plugin
export default {"messageLine":"messageCard_messageLine__11net","ownMessage":"messageCard_ownMessage__H6qXR","messageCard":"messageCard_messageCard__5aKyh"};